export * from './delete-berichts-vorlage.component';
export * from './delete-berichts-vorlage.component.module';